/* @ngInject */
const option = (
  settingFormat,
  settingRequests,
  settingInit,
  settingData
) => {
  const self = {}

  self.format = settingFormat
  self.requests = settingRequests
  self.init = settingInit
  self.data = settingData

  return self
}

export default option



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/services/setting.service.js